module.exports = __webpack_public_path__ + "img/QRCode.526ceda8.png";